import { React, useEffect, useState } from 'react';
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import { Message } from "../../../components/message";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import { HomeIcon } from "../../../components/Application/ApplicationIcon";
import dataicon from "../../../../src/assets/images/data-icon.png";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { DeleteIcon, EditIcon } from "../AdminIcon";
import { BsChevronLeft } from 'react-icons/bs'

const PrivacyPolicyGuidelinesUpdate  = () => {
  const navigate = useNavigate();

  
//   useEffect(() => {
//     getPrivacyPolicyGuidelines();
//   }, []);

//   const getPrivacyPolicyGuidelines = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("page_id", 1);
//       const usersListData = await getPrivacyPolicyGuidelinesList(formData);
//       if (usersListData.status === 200) {
//         setUserList(usersListData?.data || []);
//         setTableDataLoaded(true);
//         setprivacyPolicy_en(usersListData?.data?.content_en)
//         setprivacyPolicy_hi(usersListData?.data?.content_hi)
//       }
//     } catch (err) {
//       setApiMessage({ type: 'error', message: err?.message });
//     }
//   };

  return (
    <AdminDashboard>
      <div className="aod-outer">
        {/* {apiMessage && (<Message apiMessage={apiMessage} setApiMessage={setApiMessage}></Message>)} */}
        <div className="ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb">
        <div>
            <HomeIcon />
            <b onClick={() => navigate("/admin/")}>Home /</b>
            <b onClick={() => navigate("/admin/privacy-policy/update/")}>Privacy Policy /</b>
            <span> Guidelines</span>
          </div>
        </div>
        <div className="aod-inner pt-0">
          <div className="aod-bottom">
            <div className="aod-head text-center adm-head"><button onClick={() => navigate("/admin/privacy-policy/update")}><BsChevronLeft /> Back</button>Privacy Policy Guidelines</div>
            <div className="adm-tabs-outer">
            </div>
            <div className="ad-reg-table">
              <Table size="sm" className="ad-cat-table mt-4">
                <thead>
                  <tr>
                    <th className="ad-sno">S. No</th>
                    <th className="ad-long">District </th>
                    <th className="ad-long">Tracking Number</th>
                    <th className="ad-long">Created At</th>
                    <th className="ad-long">Expiry Date</th>
                    <th className="ad-long">Status</th>
                    <th className="ad-long">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Gurdaspur</td>
                    <td>UTTT14706601</td>
                    <td>12-10-2024</td>
                    <td>12-09-2024</td>
                    <td>Expired</td>
                    {/* <td><div className="action-btn d-flex">
                                                    <span className='ad-cat-edit' onClick={() => navigate("/admin/category/documents/update", { state: item })}><EditIcon /></span><span className='ad-cat-delete' onClick={() => setDeleteData(item)}><DeleteIcon /></span>
                                                </div>
                                                </td> */}
                    <td>
                      <div className="action-btn d-flex">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Edit</Tooltip>}
                        >
                          <span className="ad-cat-edit">
                            <EditIcon />
                          </span>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Delete</Tooltip>}
                        >
                          <span className="ad-cat-delete">
                            <DeleteIcon />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Gurdaspur</td>
                    <td>UTTT14706601</td>
                    <td>12-10-2024</td>
                    <td>12-09-2024</td>
                    <td>Expired</td>
                    {/* <td><div className="action-btn d-flex">
                                                    <span className='ad-cat-edit' onClick={() => navigate("/admin/category/documents/update", { state: item })}><EditIcon /></span><span className='ad-cat-delete' onClick={() => setDeleteData(item)}><DeleteIcon /></span>
                                                </div>
                                                </td> */}
                    <td>
                      <div className="action-btn d-flex">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Edit</Tooltip>}
                        >
                          <span className="ad-cat-edit">
                            <EditIcon />
                          </span>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Delete</Tooltip>}
                        >
                          <span className="ad-cat-delete">
                            <DeleteIcon />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Gurdaspur</td>
                    <td>UTTT14706601</td>
                    <td>12-10-2024</td>
                    <td>12-09-2024</td>
                    <td>Expired</td>
                    {/* <td><div className="action-btn d-flex">
                                                    <span className='ad-cat-edit' onClick={() => navigate("/admin/category/documents/update", { state: item })}><EditIcon /></span><span className='ad-cat-delete' onClick={() => setDeleteData(item)}><DeleteIcon /></span>
                                                </div>
                                                </td> */}
                    <td>
                      <div className="action-btn d-flex">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Edit</Tooltip>}
                        >
                          <span className="ad-cat-edit">
                            <EditIcon />
                          </span>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Delete</Tooltip>}
                        >
                          <span className="ad-cat-delete">
                            <DeleteIcon />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </AdminDashboard>
  );
};

export default PrivacyPolicyGuidelinesUpdate ;
